import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Skill, Tool} from 'common/src/modules/shared/copilot/copilot.types';
import {ZodTypeAny} from 'zod';
import {SkillName} from '../../skills/skills.enums';
import askKnowledgeRAGTool from '../../tools/askKnowledgeRAGTool/askKnowledgeRAGTool';

type CreateSkillParams = {
  name: SkillName;
  description: string;
  whenToUse: string;
  whenToAvoid?: string;
  instructions: string;
  tools: Tool<ZodTypeAny>[];
  applicableBreadcrumbs?: BreadcrumbName[];
  knowledgeTopics?: KnowledgeRagTopic[];
};

export default function skill({
  name,
  description,
  whenToUse,
  whenToAvoid = '',
  instructions,
  tools,
  applicableBreadcrumbs = [],
  knowledgeTopics = [],
}: CreateSkillParams): Skill {
  const skillTools = [...tools];

  if (knowledgeTopics.length > 0) {
    skillTools.push(askKnowledgeRAGTool({knowledgeTopics, nameSuffix: name}));
  }

  return {
    name,
    description,
    whenToUse,
    whenToAvoid,
    instructions,
    tools: skillTools,
    knowledgeTopics,
    applicableBreadcrumbs,
  };
}
